import { defineComponent as A, useSlots as H, useAttrs as K, useCssModule as L, ref as T, computed as s, watchEffect as q, nextTick as F, createBlock as f, openBlock as l, Transition as P, withCtx as m, createElementBlock as _, createCommentVNode as c, mergeProps as Y, unref as e, withKeys as j, createElementVNode as a, normalizeClass as o, toDisplayString as p, renderSlot as G, createVNode as J, createTextVNode as S } from "vue";
import y from "lodash-es/capitalize";
import O from "lodash-es/uniqueId";
import { S as B, b as g, a as I } from "./statusLevels-D8EgtE_L.js";
import { t as d } from "./locale.js";
import z from "./Button.js";
import Q from "./Icon.js";
import { _ as R } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const U = ["open", "aria-labelledby", "data-test"], W = ["id"], X = {
  key: 0,
  class: "tw-mb-0"
}, tt = ["innerHTML"], et = { class: "tw-text-right" }, ot = /* @__PURE__ */ A({
  name: "ll-dialog",
  inheritAttrs: !1,
  __name: "Dialog",
  props: {
    open: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    dangerZone: { type: Boolean, default: !1 },
    header: { default: d("ll.areYouSure") },
    description: { default: "" },
    cancelText: { default: d("ll.cancel") },
    confirmText: { default: "" },
    onConfirm: { type: Function, default: () => {
    } },
    alert: { type: Boolean, default: !1 },
    status: { default: void 0 }
  },
  emits: ["update:open", "cancel"],
  setup(D, { emit: M }) {
    const t = D, b = M, h = H(), v = K(), n = L(), w = O("dialog-header-"), r = T(!1), i = T(), E = s(() => t.confirmText || (t.alert ? d("ll.okay") : d("ll.confirm"))), x = s(() => !!h.default || t.description), N = s(
      () => t.status ? B[y(t.status)] : B.Info
    ), V = s(
      () => t.status ? g[y(t.status)] : g.Info
    ), k = s(
      () => t.status ? I[y(t.status)] : I.Info
    ), $ = s(() => t.dangerZone || t.status === g.Error);
    function C() {
      b("update:open", !1), b("cancel");
    }
    async function Z(u) {
      if (!r.value) {
        r.value = !0;
        try {
          await t.onConfirm(u);
        } finally {
          r.value = !1;
        }
      }
    }
    return q(() => {
      t.open && i.value && F(function() {
        i.value.focus();
      });
    }), (u, it) => (l(), f(P, { name: "fade" }, {
      default: m(() => [
        t.open ? (l(), _("dialog", Y({
          key: 0,
          ref_key: "root",
          ref: i,
          open: t.open,
          tabindex: "0",
          "aria-labelledby": e(w),
          "aria-modal": "true",
          class: ["stash-dialog", e(n).dialog],
          "data-test": e(v)["data-test"] || "ll-dialog"
        }, e(v), {
          onKeydown: j(C, ["esc"])
        }), [
          a("div", {
            class: o(["stash-dialog__body", [
              e(n).body,
              `tw-border-${k.value}`,
              {
                "tw-border-t-6": t.status
              }
            ]]),
            "data-test": "stash-dialog|body"
          }, [
            a("div", {
              class: o(["stash-dialog__body__content", e(n).content]),
              "data-test": "stash-dialog|body-content"
            }, [
              a("div", {
                class: o(["tw-flex tw-items-center", x.value && "tw-mb-1.5"])
              }, [
                t.status ? (l(), f(Q, {
                  key: 0,
                  "data-test": "dialog-status-icon",
                  name: N.value,
                  title: V.value,
                  class: o(`tw-text-${k.value}`)
                }, null, 8, ["name", "title", "class"])) : c("", !0),
                a("h3", {
                  id: e(w),
                  class: o({ "tw-ml-1.5 tw-mt-px": t.status })
                }, p(t.header), 11, W)
              ], 2),
              x.value ? (l(), _("p", X, [
                e(h).default ? G(u.$slots, "default", { key: 0 }) : (l(), _("span", {
                  key: 1,
                  innerHTML: t.description
                }, null, 8, tt))
              ])) : c("", !0)
            ], 2),
            a("footer", {
              class: o(["stash-dialog__footer", e(n).footer]),
              "data-test": "stash-dialog|footer"
            }, [
              a("div", et, [
                a("div", {
                  class: o({ "button-grid": !t.alert })
                }, [
                  t.alert ? c("", !0) : (l(), f(z, {
                    key: 0,
                    "data-test": "button|cancel",
                    secondary: "",
                    onClick: C
                  }, {
                    default: m(() => [
                      S(p(t.cancelText), 1)
                    ]),
                    _: 1
                  })),
                  J(z, {
                    "data-test": "button|confirm",
                    disabled: t.disabled,
                    "is-loading": r.value,
                    color: $.value ? "red" : "blue",
                    class: o({
                      "tw-w-full": t.alert
                    }),
                    onClick: Z
                  }, {
                    default: m(() => [
                      S(p(E.value), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "is-loading", "color", "class"])
                ], 2)
              ])
            ], 2)
          ], 2)
        ], 16, U)) : c("", !0)
      ]),
      _: 3
    }));
  }
}), at = "_dialog_1fzac_2", st = "_body_1fzac_19", lt = "_grey_1fzac_32", nt = "_content_1fzac_42", rt = "_footer_1fzac_47", ct = {
  dialog: at,
  body: st,
  grey: lt,
  content: nt,
  footer: rt
}, dt = {
  $style: ct
}, ht = /* @__PURE__ */ R(ot, [["__cssModules", dt]]);
export {
  ht as default
};
//# sourceMappingURL=Dialog.js.map
